import PpSelect from '@/components/Selectors/Select';
import SavedTextStylePopover from './SavedTextStylePopover';

import {
  getUniqueStylesWithPropertyName,
  isEmpty,
  toCssStyle
} from '@/common/utils';

import { EVENT_TYPE } from '@/common/constants/eventType';
import { useTextStyle } from '@/hooks/style';
import { useAppCommon, useElementProperties, useMenuProperties } from '@/hooks';
import { PROPERTIES_SELECTION_FABRICS, TWO_EM_DASH } from '@/common/constants';

export default {
  components: {
    PpSelect,
    SavedTextStylePopover
  },
  data() {
    return {
      showSavedStylePopup: false,
      componentKey: true,
      currentSelectionStyle: null
    };
  },
  setup() {
    const { userTextStyles, textStyles } = useTextStyle();
    const { getProperty } = useElementProperties();
    const { currentSelectionTextStyle } = useAppCommon();
    const { isOpenMenuProperties } = useMenuProperties();

    return {
      userTextStyles,
      textStyles,
      getProperty,
      isOpenMenuProperties,
      currentSelectionTextStyle
    };
  },
  computed: {
    selectedItem() {
      const selectedId = this.getProperty('styleId') || 'default';
      return this.selectBoxItems.find(item => item.id === selectedId);
    },
    items() {
      const userStyles = this.userTextStyles.map(style => ({
        ...style,
        isCustom: true
      }));
      return [...this.textStyles, ...userStyles];
    },
    selectBoxItems() {
      this.componentKey = !!this.componentKey;
      return this.updateTextStyle();
    }
  },
  methods: {
    /**
     * Event fired when user choose an item on list
     *
     * @param {String}  id id of style
     * @param {Object}  style attribute style of style
     */
    onChange({ id, style }) {
      this.onClose();
      if (isEmpty(id) || isEmpty(style)) return;
      style.isSelectionStyle = true;
      this.$root.$emit(EVENT_TYPE.CHANGE_TEXT_PROPERTIES, {
        ...style,
        styleId: id,
        isSelectionStyle: true
      });
      this.forceRenderComponent();
    },

    /**
     * Fire when click selectbox
     */
    onClick() {
      if (!this.userTextStyles?.length) return;
      this.componentKey = !this.componentKey;
      this.showSavedStylePopup = true;
    },

    /**
     * Handle Close saved style popup
     */
    onClose() {
      this.showSavedStylePopup = false;
    },

    /**
     * Event fired when user click outside component
     */
    onClickOutside() {
      if (!this.showSavedStylePopup) return;
      this.onClose();
    },
    forceRenderComponent() {
      this.componentKey = !this.componentKey;
    },
    updateTextStyle() {
      const textStyles = this.items.map(item => {
        const { name, id, style, isCustom } = item;
        return {
          name,
          id,
          style,
          isCustom,
          cssStyle: { ...toCssStyle(style), maxWidth: '275px' }
        };
      });
      const listStyle = getUniqueStylesWithPropertyName(
        PROPERTIES_SELECTION_FABRICS.STYLEID,
        this.currentSelectionTextStyle
      );
      if (!listStyle.length) {
        this.currentSelectionStyle = null;
        return textStyles;
      }
      const canvas = window.printCanvas || window.digitalCanvas;
      if (listStyle.length === 1) {
        if (
          canvas.getActiveObject().type === 'group' &&
          this.getProperty(PROPERTIES_SELECTION_FABRICS.STYLEID) !==
            listStyle[0][PROPERTIES_SELECTION_FABRICS.STYLEID]
        ) {
          textStyles.unshift({
            name: 'Mixed',
            value: TWO_EM_DASH
          });
          this.currentSelectionStyle = textStyles[0];
          return textStyles;
        }
        this.currentSelectionStyle = textStyles.find(
          item => item.id === listStyle[0][PROPERTIES_SELECTION_FABRICS.STYLEID]
        );
        return textStyles;
      } else {
        textStyles.unshift({
          name: 'Mixed',
          value: TWO_EM_DASH
        });
        this.currentSelectionStyle = textStyles[0];
        return textStyles;
      }
    }
  },
  watch: {
    isOpenMenuProperties(val) {
      if (!val) {
        this.onClose();
      }
    }
  }
};
